import { Project } from "../api";
import {IngestionMessage, MessageScope, ValidationMessageType} from "../asset-service-api";

export const getAsperaErrors = (project: Project) : IngestionMessage[] => {
    if (!project) return [];

    const resourcesWithErrors = project.resources?.filter(r => r.uploadError) ?? [];
    return resourcesWithErrors.map(r => {
        const track = project.trackResourceMap?.find(t => t.resourceId === r.id);
        return {
            details: "Aserpa encountered an error.",
            message: r.uploadError?.description,
            messageType: ValidationMessageType.Error,
            source: {
                scope: track ? MessageScope.Track : MessageScope.Resource,
                stage: "local",
                target: track ? track.trackId : "",
                id: "b11bf63c-cf8b-4d66-afa1-884264b8f11b",
            },
        } as IngestionMessage;
    });
};
